import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
// import Router from 'vue-router'

import axios from "axios";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {

    searchResults: [],

    SelectedIDS:
    {
      MainCatId: null,
      CatId: null,
      SubId: null,

    },


    isLoggedIn: !!localStorage.getItem("token"),
    userType: localStorage.getItem("userType"),
    // userType: 'Client',
    cartItems: 0,
    wishlistItems: 0,
    userData: {},
    coupen: {},
    buyNGetMDeal: 0,
    loginAlternate: false,
    fullPath: null,
    categories: [],
    stylCategories: [],
    subCategories: [],
  },
  mutations: {


    updateMainCatId(state, mId) {
      state.SelectedIDS.MainCatId = mId;
      // console.log("main stored=",this.state.SelectedIDS.MainCatId);
    },
    updateCatId(state, cId) {
      state.SelectedIDS.CatId = cId;
      // console.log("sub stored=",this.state.SelectedIDS.CatId);

    },
    updateSubCatId(state, sId) {
      state.SelectedIDS.SubId = sId;
      // console.log("sub stored=",this.state.SelectedIDS.SubId);

    },


    getSearchResults(state, item) {
      state.searchResults = item;
      console.log("storeitem=", item);
    },
    getInstock(state, item) {
      state.instock = item;
      console.log("storeinstock=", item);
    }, getOutstock(state, item) {
      state.outstock = item;
      console.log("storeoutstock=", item);
    },

    loginUser(state, item) {
      state.isLoggedIn = item;
    },

    LOGIN_ALTERNATE(state, item) {
      state.loginAlternate = item;
    },

    lastPage_fullPath(state, item) {
      // console.log(state,item,"fghj")
      state.fullPath = item;
    },

    logoutUser(state) {
      axios({
        method: "GET",
        url: "/user/logout",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {

        if (response.data) {
          {
            axios({
              method: "GET",
              url: "/guest/uniqueid",

            })
              .then((response) => {
                if (response.data.status) {
                  localStorage.setItem("guestId", response.data.guestId);
                  console.log("guestId", response.data.guestId);
                  console.log("test home page ");
                 
                  // router.go();
                }
              })
              .catch((err) => {
                console.log(err);
              });
              if(window.location.pathname != '/'){
                router.push('/')
              }
          }









          state.userType = "Client";
          state.userData = {};
          state.coupen = {};
          localStorage.setItem("userType", "Client");
          state.isLoggedIn = false;
          state.cartItems = 0;
          state.wishlistItems = 0;
          localStorage.removeItem("token");
          if (window.location.pathname != "/") {
            router.push("/");
          }
        }
      });
    },

    changeCart(state, item) {
      state.cartItems = item;
    },
    changeWishlist(state, item) {
      state.wishlistItems = item;
    },
    userData(state, item) {
      state.userData = item;
    },
    coupen(state, item) {
      state.coupen = item;
    },
    changePicture(state, item) {
      state.userData.image = null;
      setTimeout(() => {
        state.userData.image = item;
      }, 2000);
    },
    changeCoverPicture(state, item) {
      state.userData.seller.coverimage = null;
      setTimeout(() => {
        state.userData.seller.coverimage = item;
      }, 2000);
    },
    userType(state, item) {
      state.userType = item;
      localStorage.setItem("userType", item);
    },
    changeBuyNGetMDeal(state, item) {
      state.buyNGetMDeal = item;
    },
    sessionOut(state) {
      localStorage.removeItem("token");
      state.isLoggedIn = false;
      router.push("/");
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_STYLCATEGORIES(state, stylCategories) {
      state.stylCategories = stylCategories;
    },
    SET_SUBCATEGORIES(state, subCategories) {
      state.subCategories = subCategories;
    },
  },
  actions: {
    getCategory({ commit }) {
      axios({
        method: "GET",
        url: "/maincategory/getlist",
      })
        .then((reponse) => {
          commit("SET_CATEGORIES", reponse.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getStylCategory({ commit }) {
    // 	axios({
    // 		method: "GET",
    // 		url: "/styl/getlist",
    // 	})
    // 		.then((reponse) => {
    // 			commit('SET_STYLCATEGORIES', reponse.data.data)
    // 		})
    // 		.catch((err) => {
    // 			console.log(err);
    // 		});
    // },
    // getSubCategory({ commit }) {
    // 	console.log(state.userData._id,"hiiii")

    // 	axios({
    // 		method: "GET",
    // 		url: "/category/getlist",
    // 		params: {
    // 			mainCategoryId: router.currentRoute.query.category,
    // 			styl: router.currentRoute.query.styl,
    // 		},
    // 	})
    // 		.then((reponse) => {
    // 			commit('SET_SUBCATEGORIES', reponse.data.data)
    // 		})
    // 		.catch((err) => {
    // 			console.log(err);
    // 		});
    // },
    // 	axios({
    // 		method: "GET",
    // 		url: "/productsubcategory/getlist",
    // 		params: {
    // 			category: router.currentRoute.query.category,
    // 			styl: router.currentRoute.query.styl,
    // 		},
    // 	})
    // 		.then((reponse) => {
    // 			commit('SET_SUBCATEGORIES', reponse.data.data)
    // 		})
    // 		.catch((err) => {
    // 			console.log(err);
    // 		});
    // },
  },
})


